/**
 * Enum for Widget States
 * @readonly
 * @enum {name: {value: string}}
 */

export const WidgetStateEnum = Object.freeze({
  BorrowerNotEligible: 'BorrowerNotEligible',
  CompanyNotEligible: 'CompanyNotEligible',
  Eligible: 'Eligible',
  OutstandingLoan: 'OutstandingLoan',
  EmploymentStatusChanged: 'EmploymentStatusChanged',
  SystemUnderMaintenance: 'SystemUnderMaintenance',
  SystemMaintenance: 'SystemMaintenance',
  Error: 'Error',
  LoanRequested: 'LoanRequested',
  Unconsented: 'Unconsented',
  ConsentAgreement: 'ConsentAgreement',
  BenefitsAdmin: 'BenefitsAdmin',
  BenefitsEmployee: 'BenefitsEmployee',
  Unauthorized: 'Unauthorized',
  ServiceBreak: 'ServiceBreak',
});
